// Timeline item components
export { default as MessageItemTimeline } from './MessageItemTimeline.vue';
export { default as DateItemTimeline } from './DateItemTimeline.vue';
export { default as SimpleItemTimeline } from './SimpleItemTimeline.vue';
export { default as AtLocationTimelineItem } from './AtLocationTimelineItem.vue';

import { TimelineItemType } from '@/util/timeline'

// Component mapping for dynamic rendering (legacy, uses constructor names)
export const TimelineComponentMap = {
  MessageItem: 'MessageItemTimeline',
  UserSimpleItem: 'SimpleItemTimeline',
  DateItem: 'DateItemTimeline',
  ServiceSimpleItem: 'SimpleItemTimeline',
  PatrolSimpleItem: 'SimpleItemTimeline',
  DispatcherSimpleItem: 'SimpleItemTimeline',
  SimpleItem: 'SimpleItemTimeline',
  AtLocationItem: 'AtLocationTimelineItem',
};

// Map by stable `type` property (not affected by minification)
export const TimelineTypeMap = {
  [TimelineItemType.MESSAGE]: 'MessageItemTimeline',
  [TimelineItemType.USER_SIMPLE]: 'SimpleItemTimeline',
  [TimelineItemType.DATE]: 'DateItemTimeline',
  [TimelineItemType.SERVICE_SIMPLE]: 'SimpleItemTimeline',
  [TimelineItemType.PATROL_SIMPLE]: 'SimpleItemTimeline',
  [TimelineItemType.DISPATCHER_SIMPLE]: 'SimpleItemTimeline',
  [TimelineItemType.SIMPLE]: 'SimpleItemTimeline',
  [TimelineItemType.AT_LOCATION]: 'AtLocationTimelineItem',
};

// Helper function to get component name by timeline item type
export function getTimelineComponent(timelineItem) {
  if (!timelineItem) return 'SimpleItemTimeline'

  // Prefer explicit `type` property (stable across builds/minification)
  if (timelineItem.type) {
    const byType = TimelineTypeMap[timelineItem.type]
    if (byType) return byType
  }

  // Fallback to constructor name (legacy behavior)
  const constructorName = timelineItem.constructor && timelineItem.constructor.name
  const componentName = constructorName && TimelineComponentMap[constructorName]

  if (!componentName) {
    console.warn(
      `No timeline component found for ${constructorName || String(timelineItem)}, using SimpleItemTimeline`
    );
    return 'SimpleItemTimeline';
  }
  return componentName;
}
